{
  "bulkApplyConfirm": {
    "buttons": {
      "applying": "Anwenden",
      "cancel": "Abbrechen",
      "confirm": "Bestätigen"
    },
    "helperText": "Hilfetext",
    "loading": "Lädt",
    "message": "Massenanwendung bestätigen",
    "summary": {
      "alreadyMapped": "Bereits zugeordnet",
      "newMappings": "Neue Zuordnungen",
      "totalRows": "Zeilen gesamt"
    },
    "title": "Massenanwendung bestätigen"
  },
  "flightBridgeStatus": {
    "pendingTenants": {
      "allMatched": "Alle zugeordnet",
      "buttons": {
        "refresh": "Neu laden",
        "removeAndRetry": "Entfernen & Wiederholen"
      },
      "columns": {
        "aircraftType": "Flugzeugtyp",
        "created": "Erstellt",
        "fbo": "Fbo",
        "operator": "Betreiber",
        "source": "Quelle",
        "tailNumber": "Kennzeichen"
      },
      "description": "Beschreibung",
      "dialog": {
        "autoRetry": {
          "description": "Beschreibung",
          "title": "Auto-Retry"
        },
        "buttons": {
          "cancel": "Abbrechen",
          "removeAndRetry": "Entfernen & Wiederholen",
          "removing": "Entfernen"
        },
        "message": "Dialog",
        "reQuarantine": "Erneut quarantänen",
        "title": "Dialog"
      },
      "errors": {
        "resolveFailed": "Fehler: Auflösung fehlgeschl."
      },
      "noPendingTenants": "Keine offenen Mandanten",
      "pendingCount": "Ausstehend",
      "selectedCount": "Ausgewählt",
      "title": "Ausstehende Mieter",
      "unknownFBO": "Unbekanntes FBO",
      "unknownOperator": "Unbekannter Betreiber",
      "unknownType": "Unbekannter Typ"
    }
  },
  "obstacleEdit": {
    "buttons": {
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "save": "Speichern"
    },
    "errors": {
      "fileSizeLimit": "Fehler: Dateigrößenlimit",
      "fileTypeInvalid": "Fehler: Ungültiger Dateityp"
    },
    "helperText": {
      "keepCurrent": "Aktuell halten"
    },
    "image": {
      "changeButton": "Schaltfläche ändern",
      "preview": "Vorschau",
      "selected": "Ausgewählt",
      "uploadButton": "Hochladen-Button"
    },
    "labels": {
      "height": "Höhe",
      "length": "Länge",
      "name": "Name",
      "obstacleImage": "Hindernisbild",
      "width": "Breite"
    },
    "placeholders": {
      "height": {
        "create": "Erstellen",
        "edit": "Bearb."
      },
      "length": {
        "create": "Erstellen",
        "edit": "Bearb."
      },
      "name": {
        "create": "Erstellen"
      },
      "width": {
        "create": "Erstellen",
        "edit": "Bearb."
      }
    },
    "title": {
      "create": "Erstellen",
      "edit": "Ändern"
    }
  },
  "towingEquipmentEdit": {
    "buttons": {
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "save": "Speichern"
    },
    "helperText": {
      "keepCurrent": "Aktuell halten",
      "noFootprint": "Keine Maße"
    },
    "labels": {
      "height": "Höhe",
      "length": "Länge",
      "name": "Name",
      "noFootprint": "Keine Maße",
      "towBar": "Zugstange",
      "width": "Breite"
    },
    "placeholders": {
      "height": {
        "create": "Erstellen",
        "edit": "Bearb."
      },
      "length": {
        "create": "Erstellen",
        "edit": "Bearb."
      },
      "name": {
        "create": "Erstellen"
      },
      "towBar": {
        "create": "Erstellen",
        "edit": "Ändern"
      },
      "width": {
        "create": "Erstellen",
        "edit": "Ändern"
      }
    },
    "title": {
      "create": "Erstellen",
      "edit": "Ändern"
    }
  }
}
